import { testimonialList } from "@/mocks/content";

export default function About() {
  return (
    <>
      <section id="about" className="w-full bg-background-100 py-20 md:py-24">
        <div className="container-site grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div>
            <span className="inline-block rounded-full bg-accent-100 px-4 py-1.5 text-sm font-semibold text-accent-700">
              关于小猴看番
            </span>
            <h2 className="mt-5 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
              只做一件事,让你顺畅追更
            </h2>
            <p className="mt-5 text-base leading-relaxed text-foreground-700">
              小猴看番专注聚合多线路播放源,以「自动选源 + 手动秒切」为核心,把「看番卡顿」这个老大难问题彻底解决。无论是热门新番同步首播,还是经典老番补番怀旧,我们都会为你准备足够的可播线路与备用线路。
            </p>
            <p className="mt-4 text-base leading-relaxed text-foreground-700">
              我们相信,好的观看体验不需要复杂的操作。开播自动选源,卡顿手动秒切,多源播放稳定兜底——把时间留给剧情,把麻烦交给我们。
            </p>

            <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-3">
              {[
                { icon: "ri-heart-line", text: "内容为本" },
                { icon: "ri-shield-check-line", text: "稳定可靠" },
                { icon: "ri-thumb-up-line", text: "体验至上" },
              ].map((item) => (
                <div key={item.text} className="flex items-center gap-2 rounded-md bg-background-50 px-4 py-3 text-sm font-semibold text-foreground-800">
                  <i className={`${item.icon} text-lg text-primary-600`} aria-hidden="true"></i>
                  {item.text}
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-4">
            {testimonialList.map((item) => (
              <figure key={item.name} className="rounded-lg border border-background-200 bg-background-50 p-5">
                <div className="flex gap-0.5 text-secondary-400">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm" aria-hidden="true"></i>
                  ))}
                </div>
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">“{item.text}”</blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className={`flex h-9 w-9 items-center justify-center rounded-full text-sm font-bold ${item.color}`}>
                    {item.name[0]}
                  </span>
                  <span>
                    <span className="block text-sm font-semibold text-foreground-950">{item.name}</span>
                    <span className="block text-xs text-foreground-500">{item.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      <section className="relative w-full overflow-hidden py-16 md:py-20">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Wide%20stylized%20anime%20banner%20of%20a%20night%20city%20skyline%20with%20fireworks%20in%20warm%20coral%20orange%20and%20teal%20tones%2C%20playful%20monkey%20silhouette%20jumping%20between%20rooftops%2C%20cinematic%20atmosphere%2C%20clean%20artistic%20composition%2C%20no%20text%2C%20high%20quality%20digital%20illustration&width=1600&height=600&seq=cta-bg-2026&orientation=landscape"
            alt="小猴看番多线路稳定追更横幅背景"
            className="h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 to-primary-950/60"></div>
        </div>

        <div className="container-site relative z-10 flex w-full flex-col items-center text-center">
          <h2 className="max-w-2xl font-heading text-3xl font-bold text-background-50 md:text-4xl">
            别再为卡顿错过名场面,现在就开始顺畅追更
          </h2>
          <p className="mt-4 max-w-xl text-base text-background-100/90">
            热门新番、经典老番、国漫剧场版,多线路自动选源 + 手动秒切,一路稳定畅看。
          </p>
          <a href="#anime" className="mt-8 inline-flex items-center justify-center whitespace-nowrap rounded-full bg-secondary-500 px-8 py-3.5 text-base font-semibold text-background-50 transition-colors hover:bg-secondary-600">
            <i className="ri-play-fill mr-1" aria-hidden="true"></i>
            立即开始看番
          </a>
        </div>
      </section>
    </>
  );
}